/**
 * Simple state manager to track when a drag operation is in progress.
 * This is used to prevent SignalR from triggering redundant fetches
 * that would cause UI flickering during drag-and-drop operations.
 * 
 * The state is local to each browser/app instance, so other devices
 * will still receive SignalR updates normally.
 */

let isDragOperationInProgress = false;
let operationTimeout = null;

// Safety timeout to auto-clear the flag after 10 seconds
// in case something goes wrong and clearDragOperation isn't called
const SAFETY_TIMEOUT_MS = 10000;

/**
 * Call this when starting a drag operation that will make an API call.
 * This will cause SignalR FileUpdated events to be ignored temporarily.
 */
export const setDragOperationInProgress = () => {
    isDragOperationInProgress = true;
    
    // Clear any existing timeout
    if (operationTimeout) {
        clearTimeout(operationTimeout);
    }
    
    // Safety timeout to auto-clear
    operationTimeout = setTimeout(() => {
        if (isDragOperationInProgress) {
            isDragOperationInProgress = false;
        }
    }, SAFETY_TIMEOUT_MS);
};

/**
 * Call this when the drag operation's API call has completed.
 * This will re-enable SignalR FileUpdated event handling.
 */
export const clearDragOperation = () => {
    isDragOperationInProgress = false;
    
    if (operationTimeout) {
        clearTimeout(operationTimeout);
        operationTimeout = null;
    }
};

/**
 * Check if a drag operation is currently in progress.
 * @returns {boolean} True if a drag operation is in progress
 */
export const isDragInProgress = () => {
    return isDragOperationInProgress;
};

